module.exports = __webpack_public_path__ + "static/media/4.15c3efd1.jpg";